import React from "react";

const GuideIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox={`0 0 28 28`}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Everything-you-need-at-your-finger-tips-Copy-16"
          transform="translate(-1536, -140)"
          fillRule="nonzero"
        >
          <g id="Group-13" transform="translate(241, 131.6552)">
            <g id="Group-11" transform="translate(1279.6207, 0)">
              <g id="Group-15" transform="translate(15.3793, 8.3448)">
                <g id="Group-10" fill="#000000">
                  <circle id="Oval" cx="14" cy="14" r="14"></circle>
                </g>
                <path
                  d="M13.0014904,18.6714991 C13.2107919,18.671789 13.4040355,18.7805396 13.5084284,18.9567863 C13.6128213,19.1330331 13.6125036,19.3499998 13.5075951,19.5259573 C13.4026865,19.7019148 13.2091252,19.8101309 12.9998237,19.8098422 C12.6762717,19.8093945 12.4143541,19.5542055 12.4148138,19.239861 C12.4152746,18.9255166 12.6779384,18.6710526 13.0014904,18.6714991 M22.1883043,15.1520316 C21.9790029,15.1518868 21.7856798,15.0432698 21.681158,14.8670953 C21.5766362,14.6909209 21.576795,14.4739542 21.6815746,14.2979244 C21.7863543,14.1218946 21.9798362,14.0135448 22.1891376,14.0136893 C22.5126896,14.013913 22.7747938,14.2689208 22.7745638,14.5832653 C22.7743336,14.8976097 22.5118563,15.152255 22.1883043,15.1520316 M22.1883043,12.8235311 C21.1881133,12.8244238 20.3775275,13.6119422 20.3766086,14.5836701 C20.3766086,14.7723142 20.4091091,14.9601487 20.4724435,15.1431255 L14.4881809,18.2383468 C14.1513325,17.7631652 13.595364,17.479467 13.0014904,17.4797221 C12.310646,17.4797221 11.6814693,17.8642971 11.3764644,18.464234 L6.0005449,15.7098675 C5.43220246,15.4200195 5.00719565,14.5116129 5.05219637,13.6841694 C5.07553007,13.2526358 5.22886586,12.9174484 5.46303628,12.7879073 C5.61137199,12.7069442 5.78970819,12.7134212 5.97971123,12.8097674 L6.01471179,12.8283889 C7.43973463,13.5570573 12.101476,15.9430414 12.2981458,16.0312913 C12.6006507,16.168119 12.7689867,16.2231739 13.2856616,15.9851423 L22.9224827,11.1160182 C23.0641517,11.0642018 23.2291543,10.9322318 23.2291543,10.7322529 C23.2291543,10.4553589 22.9341496,10.3460586 22.9333162,10.3460586 C22.3849741,10.0910247 21.5424606,9.70806896 20.7207808,9.33401919 C18.964086,8.53491287 16.9732207,7.62974481 16.0990401,7.18444746 C15.344028,6.80068212 14.7365182,7.12453473 14.6281832,7.18930525 L14.4181798,7.2905092 C10.4831167,9.18099883 5.21636566,11.7151455 4.91636086,11.8924548 C4.38051894,12.2098304 4.04801361,12.8421526 4.00467958,13.6266856 C3.93801185,14.8710893 4.5905223,16.1689286 5.52470394,16.6441823 L11.209795,19.4924661 C11.3392442,20.3573014 12.1019605,20.9990514 13.0014904,21 C13.9902267,20.9983737 14.7955497,20.2278503 14.8123528,19.2673885 L21.0741198,15.9697593 C21.3907915,16.2110295 21.7849645,16.3429994 22.1883043,16.3429994 C23.1884954,16.3421067 23.9990811,15.5545883 24,14.5828604 C23.9990811,13.6111326 23.1884954,12.8236142 22.1883043,12.8227215"
                  id="Shape"
                  fill="#FFFFFF"
                  opacity="0.800000012"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default GuideIcon;
